import { render, staticRenderFns } from "./ProductRuleEdit.vue?vue&type=template&id=2cf94cbe&"
import script from "./ProductRuleEdit.vue?vue&type=script&lang=js&"
export * from "./ProductRuleEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports